import { httpCore } from "../../config/http";
import { versionVeiculoType } from "../../config/Versions";
import { tipoVeiculo } from "../../config/Paths";
import { changeLoading } from "./loading.action";
import { changeNotify } from "./notify.action";


export const actionTypes = {
  INDEX: "VEHICLETYPES_INDEX",
  SHOW: "VEHICLETYPES_SHOW",
  DESTROY: "VEHICLETYPES_DESTROY",
  CHANGE: "VEHICLETYPES_CHANGE",
  SUCCESS: "VEHICLETYPES_SUCCESS",
  ERROR: "VEHICLETYPES_ERROR",
};

export const change = (payLoad) => ({
  type: actionTypes.CHANGE,
  payLoad,
});

export const success = (payLoad) => ({
  type: actionTypes.SUCCESS,
  payLoad,
});

export const error = (payLoad) => ({
  type: actionTypes.ERROR,
  payLoad,
});

//INDEX
export const indexResponse = (payLoad) => ({
  type: actionTypes.INDEX,
  payLoad,
});

export const index = () => (dispatch) => {
  return httpCore
    .get(versionVeiculoType + tipoVeiculo)
    .then(function (res) {
      if (res.response !== "undefined") {
        if (res.request.status === 200) {
          dispatch(indexResponse(res.data.data));
          return res.data.data;
        }
      }
    })
    .catch((error) => {
      // Error
      if (error.response) {
        //A solicitação foi feita e o servidor respondeu com um código de status fora do intervalo 2XX
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        //  A solicitação foi feita, mas nenhuma resposta foi recebida
       
      } else {
        // Algo aconteceu na configuração da solicitação que acionou um erro
        console.log("Error", error.message);
      }
      dispatch(
        changeNotify({
          open: true,
          class: "error",
          msg: "Erro ao carregar lista do servidor",
        })
      );
    });
};

//STORE
export const store = (tipoveiculo) => (dispatch) => {
  return httpCore
    .post(versionVeiculoType + tipoVeiculo, {
      descricao: tipoveiculo["descricao"],
      // tracao: tipoveiculo["tracao"],
      // reboque: tipoveiculo["reboque"],
    })
    .then((res) => {
      if (typeof res !== "undefined") {
        if (res.status === 200 || res.status === 201) {
          dispatch(
            changeNotify({
              open: true,
              class: "success",
              msg: tipoveiculo["descricao"] + " cadastrado com sucesso",
            }),
            console.log(res)
          );
          dispatch(index());
        } else {
          dispatch(
            changeNotify({
                open: true,
                class: "error",
                msg: "Ocorreu um erro ao salvar dados de tipo de veículo. Tente refazer a operação.",
            }));
        }
      }
    })
    .catch((erro) => {
      dispatch(
        changeNotify({
            open: true,
            class: "error",
            msg: "Ocorreu um erro ao salvar dados de tipo de veículo. Tente refazer a operação.",
        }));
    });
};

//UPDATE
export const update = (data) => (dispatch) => {
  dispatch(
    changeLoading({
      open: true,
    })
  );
  return httpCore
    .put(versionVeiculoType + tipoVeiculo + data.id, data)
    .then((res) => {
      dispatch(
        changeLoading({
          open: false,
        })
      );
      if (res !== "undefined") {
        if (res.status === 200 || res.status === 201) {
          dispatch(
            changeNotify({
              open: true,
              class: "success",
              msg: "Alterado com sucesso",
            })
          );
        }
        dispatch(index());
      }
    })
    .catch((erro) => {
      dispatch(
        changeNotify({
            open: true,
            class: "error",
            msg: "Ocorreu um erro ao salvar dados de tipo de veículo. Tente refazer a operação.",
        }));
    });
};

//DESTROY
export const destroyResponse = (payLoad) => ({
  type: actionTypes.DESTROY,
  payLoad,
});

export const destroy = (id) => (dispatch) => {
  dispatch(
    changeLoading({
      open: true,
      msg: "Deletando...",
    })
  );
  return httpCore
    .delete(versionVeiculoType + tipoVeiculo + id)
    .then((res) => {
      if (res !== "undefined") {
        if (res.status === 200) {
          dispatch(
            changeLoading({
              open: false,
            })
          );
          dispatch(
            changeNotify({
              open: true,
              class: "success",
              msg: "Excluido com Sucesso",
            })
          );
          dispatch(destroyResponse(id));
        }
        dispatch(index());
      }
    })
    .catch((error) => {
      // Error
      if (error.response) {
        //A solicitação foi feita e o servidor respondeu com um código de status fora do intervalo 2XX
        if (error.response.status === 404) {
          dispatch(
            changeLoading({
              open: false,
            })
          );
          dispatch(
            changeNotify({
              open: true,
              class: "error",
              msg: "Tipo de veículo não encontrado",
            })
          );
        }
      } else if (error.request) {
        //  A solicitação foi feita, mas nenhuma resposta foi recebida
        dispatch(
          changeLoading({
            open: false,
          })
        );
        dispatch(
          changeNotify({
            open: true,
            class: "error",
            msg: "Sem resposta do servidor",
          })
        );
        dispatch(index());
        console.log(error.request);
      } else {
        // Algo aconteceu na configuração da solicitação que acionou um erro
        console.log("Error", error.message);
        dispatch(
          changeNotify({
              open: true,
              class: "error",
              msg: "Ocorreu um erro ao remover o tipo de veículo. Tente refazer a operação.",
          }));
      }
      // console.log(error.config);
      
    });
};
